import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import Button from '../button';
import Icon from '../icon';

class MultilingualIntroDialog extends React.Component {
  multilingualIntroDialogScrollerRef;

  static defaultProps = {
    captions: {
      title: 'Create a multilingual site',
      description: '',
      list: [],
      buttonTitle: 'Get started',
    },
  };

  constructor(props) {
    super(props);
    this.multilingualIntroDialogScrollerRef = React.createRef();
    this.state = {
      isScrollable: false,
    };

    this.setIsScrollable = this.setIsScrollable.bind(this);
  }

  componentDidMount() {
    this.setIsScrollable();
    window.addEventListener('resize', this.setIsScrollable);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setIsScrollable);
  }

  setIsScrollable() {
    const { current } = this.multilingualIntroDialogScrollerRef;
    this.setState({ isScrollable: current.scrollHeight > current.offsetHeight });
  }

  render() {
    const { onButtonClick, captions, imageUrl } = this.props;
    const { isScrollable } = this.state;

    return (
      <div
        className={classNames('ws-multilingual-intro-dialog', {
          'ws-multilingual-intro-dialog--mobile': bowser.mobile,
        })}
      >
        <div
          className={classNames('ws-multilingual-intro-dialog__scroller', {
            'ws-multilingual-intro-dialog__scroller--centred': !isScrollable,
          })}
          ref={this.multilingualIntroDialogScrollerRef}
        >
          <div
            className="ws-multilingual-intro-dialog__image"
            style={{
              backgroundImage: `url(${imageUrl})`,
            }}
          >
            <div className="ws-multilingual-intro-dialog__image-overlay" />
          </div>
          <div className="ws-text ws-text--type-heading-2 ws-text--theme-default ws-multilingual-intro-dialog__title">
            {captions.title}
          </div>
          <div className="ws-text ws-text--type-heading-5 ws-text--theme-default ws-multilingual-intro-dialog__description">
            {captions.description}
          </div>
          <div className="ws-text ws-text--type-heading-5 ws-text--theme-default ws-multilingual-intro-dialog__list">
            {captions.list.map((item) => (
              <div key={item} className="ws-multilingual-intro-dialog__list-item">
                <div className="ws-multilingual-intro-dialog__list-item-icon">
                  <Icon glyph="check" stroke="#428DFF" size="18" strokeWidth="2" />
                </div>
                <div className="ws-multilingual-intro-dialog__list-text">{item}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="ws-multilingual-intro-dialog__button-container">
          <Button type="primary" size="large" onClick={onButtonClick}>
            {captions.buttonTitle}
          </Button>
        </div>
      </div>
    );
  }
}
export default MultilingualIntroDialog;
